import { render, staticRenderFns } from "./DonationAmount.vue?vue&type=template&id=4fd940b7&"
import script from "./DonationAmount.vue?vue&type=script&lang=js&"
export * from "./DonationAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports